export const CRASH_RECONNECT_LOG_PREFIX = '[CrashReconnect]';

export function logCrashReconnect(event: string, extra?: unknown): void {
  if (extra !== undefined) {
    console.log(`${CRASH_RECONNECT_LOG_PREFIX} ${event}`, extra);
    return;
  }
  console.log(`${CRASH_RECONNECT_LOG_PREFIX} ${event}`);
}
